/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BridgeApiFriendOrganisationV2 } from './BridgeApiFriendOrganisationV2';
import {
    BridgeApiFriendOrganisationV2FromJSON,
    BridgeApiFriendOrganisationV2FromJSONTyped,
    BridgeApiFriendOrganisationV2ToJSON,
    BridgeApiFriendOrganisationV2ToJSONTyped,
} from './BridgeApiFriendOrganisationV2';

/**
 * 
 * @export
 * @interface BridgeApiFriendOrganisationsV2
 */
export interface BridgeApiFriendOrganisationsV2 {
    /**
     * 
     * @type {Array<BridgeApiFriendOrganisationV2>}
     * @memberof BridgeApiFriendOrganisationsV2
     */
    content: Array<BridgeApiFriendOrganisationV2>;
}

/**
 * Check if a given object implements the BridgeApiFriendOrganisationsV2 interface.
 */
export function instanceOfBridgeApiFriendOrganisationsV2(value: object): value is BridgeApiFriendOrganisationsV2 {
    if (!('content' in value) || value['content'] === undefined) return false;
    return true;
}

export function BridgeApiFriendOrganisationsV2FromJSON(json: any): BridgeApiFriendOrganisationsV2 {
    return BridgeApiFriendOrganisationsV2FromJSONTyped(json, false);
}

export function BridgeApiFriendOrganisationsV2FromJSONTyped(json: any, ignoreDiscriminator: boolean): BridgeApiFriendOrganisationsV2 {
    if (json == null) {
        return json;
    }
    return {
        
        'content': ((json['content'] as Array<any>).map(BridgeApiFriendOrganisationV2FromJSON)),
    };
}

export function BridgeApiFriendOrganisationsV2ToJSON(json: any): BridgeApiFriendOrganisationsV2 {
    return BridgeApiFriendOrganisationsV2ToJSONTyped(json, false);
}

export function BridgeApiFriendOrganisationsV2ToJSONTyped(value?: BridgeApiFriendOrganisationsV2 | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'content': ((value['content'] as Array<any>).map(BridgeApiFriendOrganisationV2ToJSON)),
    };
}

